<template>
  <v-container>
    <div class="row">
      <div class="col-4 align-self-center">
        <v-file-input
          :label="$t('components.portal.image_uploader.file')"
          v-on:change="handleFileChange"
          v-model="file"
          ref="fileIcon"
          accept=".jpg, .jpeg, .png"
        ></v-file-input>
      </div>
      <div class="col-auto align-self-center" v-if="fileBase64 !== undefined">
        <v-img :src="fileBase64"></v-img>
      </div>

      <div class="col-auto align-self-center">
        <v-btn
          color="primary"
          @click="submitFile"
          :disabled="!file"
          :loading="saving"
        >
          {{ $t("globals.upload") }}
        </v-btn>
      </div>
    </div>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ApiService from "@/services/api.service";
export default {
  data: () => ({
    file: undefined,
    fileBase64: undefined,
    saving: false,
  }),
  computed: {
    ...mapGetters("common", ["settings"]),
    ...mapGetters("plansMembers", ["planIdentity"]),
  },
  methods: {
    ...mapActions("downloadCenter", ["saveIcon"]),
    readFileAsDataUrlAsync(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = () => {
          resolve(reader.result);
        };

        reader.onerror = reject;

        reader.readAsDataURL(file);
      });
    },
    async handleFileChange(file) {
      if (!file) {
        this.file = undefined;
        this.$emit("clear");
        return;
      }
      this.file = file;
      this.fileBase64 = await this.readFileAsDataUrlAsync(file);
    },
    async submitFile() {
      this.$emit("upload-started");
      this.saving = true;
      try {
        const res = await this.postFile();
        this.$emit("upload-completed", res.data);
      } catch (error) {
        // console.log(error);
        this.$emit("upload-error", error);
      } finally {
        this.saving = false;
      }
    },
    postFile() {
      let formData = new FormData();
      formData.append("files", this.file);
      const url = `${this.settings.DOCUMENTSERVICEURL}Api/UploadFilesFormData/${
        this.planIdentity.UniqueIdentifier
      }_portal`;
      return ApiService.postFile(url, formData);
    },
  },
};
</script>
<style></style>
